if (window.acf) {
  window.acf.addAction("render_block_preview/type=service-grid", ($block) => {
    $block = $block[0].querySelector(".service-grid");

    $block.style.setProperty(`--sg-container-width`, `${$block.offsetWidth}px`);
    window.addEventListener("resize", () => {
      $block.style.setProperty(`--sg-container-width`, `${$block.offsetWidth}px`);
    });
  });
} else {
  document.querySelectorAll(".service-grid").forEach((grid) => {
    grid.style.setProperty(`--sg-container-width`, `${grid.offsetWidth}px`);
    window.addEventListener("resize", () => {
      grid.style.setProperty(`--sg-container-width`, `${grid.offsetWidth}px`);
    });
  });
}

{
  const computeHeight = (content) => {
    //to avoid screen jank, CSS starts the content at height:0,
    //so we set it to auto real quick to get the computed height,
    //then set it back to 0 before the trolls notice.
    content.style.setProperty("--content-closed-height", `auto`);
    content.style.setProperty("--content-open-height", `auto`);
    content.style.setProperty("--content-open-height", `${content.offsetHeight}px`);
    content.style.setProperty("--content-closed-height", `0px`);
  };

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      //only update the computed height if the width changes
      if (entry.target.lastWidth && entry.target.lastWidth != entry.contentRect.width) {
        computeHeight(entry.target);
      }
      entry.target.lastWidth = entry.contentRect.width;
    });
  });

  document.querySelectorAll(".service-details-accordion .sd-accordion-content-container").forEach((content) => {
    computeHeight(content);
    resizeObserver.observe(content);
  });
}
